import { render, staticRenderFns } from "./priceModal.vue?vue&type=template&id=7cf23f49&scoped=true&"
import script from "./priceModal.vue?vue&type=script&lang=js&"
export * from "./priceModal.vue?vue&type=script&lang=js&"
import style0 from "./priceModal.vue?vue&type=style&index=0&id=7cf23f49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf23f49",
  null
  
)

export default component.exports